import React from 'react';

import RadioButton from '../../../../Form/RadioButton/RadioButton';
import { FilterField } from '../Types';

interface Props {
    field: FilterField;
    onChange: (field: FilterField) => void;
}

const AgeGroupComponent: React.FunctionComponent<Props> = (props) => {
    return (
        <div className="filter-item">
            <RadioButton
                name="age"
                onChange={() => props.onChange(props.field)}
                checked={props.field.checked}
                value={props.field.filterValue}
                disabled={props.field.disabled}
                label={props.field.label}
                infoTitle={props.field.infoTitle ? props.field.infoTitle : props.field.label}
                infoText={props.field.description}
            />
        </div>
    );
};

export default AgeGroupComponent;
